import { Project, Tenant } from "graphql/_Types";
import { ProjectFolderDjango } from "pages/gdt/folders/ProjectFoldersProvider.api";
import { DataTableStoreState } from "pages/gdt/store/DataTableProvider.types";
import { ProjectHeaderNavProject } from "./ProjectHeaderNavProject";
import { HeaderNavSpace } from "./HeaderNavSpace";
import { HeaderNav } from "./HeaderNav";

export interface ProjectHeaderNavProps {
  project: Pick<Project, "isDemo" | "name" | "key">;
  folders: ProjectFolderDjango[];
  selectedTableId: string | undefined;
  currentTenant: Pick<Tenant, "name" | "key" | "tenantType">;
  tables: DataTableStoreState["tables"][number][];
  isCurrentUsersPersonalSpace: boolean;
}

export const ProjectHeaderNav = ({
  project,
  folders,
  selectedTableId,
  currentTenant,
  tables,
  isCurrentUsersPersonalSpace,
}: ProjectHeaderNavProps) => {
  return (
    <HeaderNav>
      <ProjectHeaderNavProject
        project={project}
        currentTenant={currentTenant}
        folders={folders}
        tables={tables}
        selectedTableId={selectedTableId}
      />
      {
        // don't show org link in demo projects
        !project.isDemo && (
          <HeaderNavSpace
            currentTenant={currentTenant}
            isCurrentUsersPersonalSpace={isCurrentUsersPersonalSpace}
          />
        )
      }
    </HeaderNav>
  );
};
